export default __webpack_public_path__ + "static/femme-donnant-formation-e518d2d6a8d54a509d02a7ac289a3d99.jpg";